// total cube formula where Data dimention array of the product
export function getTotalCubicUnits(data) {
  return data
    ?.reduce((total, item) => {
      const volume = (item.length * item.width * item.height) / 1728;
      return total + volume;
    }, 0)
    .toFixed(2);
}
